import {Component, OnInit, ViewChild} from '@angular/core';
import {User} from "../../models/Users";
import {UserService} from "../../Services/Users.service";
import {ActivatedRoute, Router} from "@angular/router";
import {formatNumber, isValidNumber, parse} from "libphonenumber-js";
import {NgForm} from "@angular/forms";
import {Configuration} from '../../config/config';
import {TranslateService} from "@ngx-translate/core";
declare var $;

@Component({
  selector: 'app-isolated-profile-update',
  templateUrl: './isolated-profile-update.component.html',
  styleUrls: ['./isolated-profile-update.component.css']
})
export class IsolatedProfileUpdateComponent implements OnInit {

  @ViewChild('userForm') userForm: NgForm;

  userUpdateStatusCode : string = "";
  errorMsg : string = "";
  User : User = new User();
  fullname : string;
  notificationList : Array<any> = [];
  getNotificationCount : number;
  noNotification:boolean = true;
  user_id: string = '';
  countryCodeList : any;
  format: any;
  parse: any;
  contact : string = "";
  isPrivacyProtected: boolean = false;
  loginMsg = '';
  isDataShow:boolean = false;
  screenWidth: number = 1366;
  screenHeight: number;
  redirectUrl: string = '';

  globalCommRoleList : Array<any> = [];
  globalBUnitList : Array<any> = [];
  communityRoleList : Array<any> = [];
  businessUnitList : Array<any> = [];
  comm_role = undefined;
  business_unit = undefined;
  isDisableBUnit: boolean = false;
  isDisableCommRole: boolean = false;
  community_id: string = '';
  countryCode : string = undefined;
  countryId : string = undefined;

  constructor(private userService : UserService,  private router : Router, private route: ActivatedRoute, private translateService: TranslateService) {
    this.countryCodeList = Configuration.countryCode;
    let lang_name = localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English';
    this.translateService.use(lang_name);
    this.translateService.reloadLang(lang_name);
  }

  ngOnInit() {
    $(document).ready(function() {
      $("#disablePrevent").on("contextmenu",function(){
        return false;
      });
    });
    $("header").css('display','none');
    $("footer").css('display','none');
    $("body").addClass("isolatedBg");
    window.name = 'isolatedProfileUpdateScreen';
    $("#preloader").css('display','block');
    this.screenWidth = screen.width || window.screen.width;
    this.screenHeight = screen.height || window.screen.height;
    window.addEventListener("orientationchange", () => {
      // Announce the new orientation number
      if (window.orientation == 90) {
        this.screenWidth = screen.width || window.screen.width;
        this.screenHeight = screen.height || window.screen.height;
      } else {
        this.screenWidth = screen.width || window.screen.width;
        this.screenHeight = screen.height || window.screen.height;
      }
    });
    this.route.params.subscribe(params => {
      if(params['url']){
        let id = params['url'];
        if(id && id.includes('http')){
          this.redirectUrl = decodeURIComponent(id);
        }
      }
    });

    const theCommunity = JSON.parse(localStorage.getItem('currentUser'));
    let Role = localStorage.getItem('userRole');
    if(Role && (Role == 'Learner' || Role == 'Manager')){
      if(theCommunity && theCommunity.user && theCommunity.user.userid){
        let user_id = theCommunity.user.userid;
        this.userService.usersProfilePic(user_id).subscribe(res=>{
          if(res.success){
            if(res.data) {
              let comm_id = res.data.community_id;
              if(comm_id){
                this.userService.getCommunityLogo(comm_id).subscribe(result=>{
                  if(result.success){
                    if(result.privacy_protected){
                      this.isPrivacyProtected = true;
                      this.isDataShow = false;
                      $("#preloader").css('display','none');
                      $('#profilesuccessModal').modal('show');
                    }else{
                      this.User = res.data;
                      this.User.comm_role = res.data.comm_role && res.data.comm_role.length > 0 && res.data.comm_role != 'None' ? res.data.comm_role : undefined;
                      this.User.business_unit = res.data.business_unit && res.data.business_unit.length > 0 && res.data.business_unit != 'None' ? res.data.business_unit : undefined;
                      this.User.organization = result.data.org_name;
                      if(this.User.country){
                        let a = this.countryCodeList.findIndex(code=> code.name == this.User.country);
                        if(a > -1){
                          this.countryCode = this.countryCodeList[a].code;
                          this.countryId = this.countryCodeList[a].iso2;
                        }else{
                          this.countryCode = undefined;
                          this.countryId = undefined;
                        }
                      }else{
                        this.countryCode = undefined;
                        this.countryId = undefined;
                      }
                      this.getAllRoleBUnit();
                      this.isPrivacyProtected = false;
                      this.isDataShow = true;
                      $("#preloader").css('display','none');
                    }
                  }else{
                    $("#preloader").css('display','none');
                    // this.router.navigate(['/isolatedLogin']);
                  }
                });
              }
            }else{
              $("#preloader").css('display','none');
              // this.router.navigate(['/isolatedLogin']);
            }
          }else{
            $("#preloader").css('display','none');
            // this.router.navigate(['/isolatedLogin']);
          }
        });
      }else{
        $("#preloader").css('display','none');
        this.loginMsg = '200';
        this.isDataShow = false;
        $('#profilesuccessModal').modal('show');
      }
    }else{
	    $("#preloader").css('display','none');
        this.loginMsg = '201';
        this.isDataShow = false;
        $('#profilesuccessModal').modal('show');
    }
  }

  getAllRoleBUnit(){
    this.userService.getRoleAndBusinessUnitById(this.User.community_id).subscribe(rb =>{
      if(rb.success){
        if(rb.data && rb.data.length > 0){
          let resArr = rb.data;
          let ind = resArr.findIndex(r=> r.comm_id == 'global');
          if(ind > -1){
            this.globalCommRoleList = resArr[ind].comm_role && resArr[ind].comm_role.length > 0 ? resArr[ind].comm_role : [];
            this.globalBUnitList = resArr[ind].business_unit && resArr[ind].business_unit.length > 0 ? resArr[ind].business_unit : [];
            resArr.splice(ind,1);
            if(resArr && resArr.length > 0){
              this.communityRoleList = resArr[0].comm_role && resArr[0].comm_role.length > 0 ? resArr[0].comm_role : this.globalCommRoleList;
              this.businessUnitList = resArr[0].business_unit && resArr[0].business_unit.length > 0 ? resArr[0].business_unit : [];
            }else{
              this.communityRoleList = (this.globalCommRoleList && this.globalCommRoleList.length > 0) ? JSON.parse(JSON.stringify(this.globalCommRoleList)) : [];
              this.businessUnitList = []; // JSON.parse(JSON.stringify(this.globalBUnitList));
            }
          }else{
            this.globalCommRoleList = [];
            this.globalBUnitList = [];
            let cind = resArr.findIndex(r=> r.comm_id == this.User.community_id);
            if(cind > -1){
              this.communityRoleList = resArr[cind].comm_role && resArr[cind].comm_role.length > 0 ? resArr[cind].comm_role : [];
              this.businessUnitList = resArr[cind].business_unit && resArr[cind].business_unit.length > 0 ? resArr[cind].business_unit : [];
            }else{
              this.communityRoleList = [];
              this.businessUnitList = [];
            }
          }
          this.follwRules();
        }

      }
    });
  }

  follwRules(){
    if(this.User.community_id == 'global'){
      this.businessUnitList = []; // JSON.parse(JSON.stringify(this.businessUnitList));
      this.User.business_unit = 'None';
      this.isDisableBUnit = true;
    }else{
      if(this.businessUnitList && this.businessUnitList.length > 0){
        if(this.businessUnitList.length == 1){
          this.isDisableBUnit = true;
          this.User.business_unit = this.businessUnitList[0];
        }else{
          this.isDisableBUnit = false;
        }
      } else{
        this.User.business_unit = 'None';
        this.isDisableBUnit = true;
      }
    }

    if(this.communityRoleList && this.communityRoleList.length > 0){
      //For CommRole
      if(this.communityRoleList.length == 1){
        this.isDisableCommRole = true;
        this.User.comm_role = this.communityRoleList[0];
      }else{
        this.isDisableCommRole = false;
      }
    } else{
      this.User.comm_role = 'None';
      this.isDisableCommRole = true;
    }
  }

  updateMyData(userForm){
    this.trimData();
    if(this.errorMsg == "") {
      $("#preloader").css('display','block');
      const theCommunity = JSON.parse(localStorage.getItem('currentUser'));
      const updated_by = theCommunity.user.userid;
      this.User.updated_by = updated_by;

      this.userService.updateUser(this.User)
        .subscribe(result => {
          this.userUpdateStatusCode = result.statusCode;
          if (result.success){
            this.fullname = this.User.first_name + ' ' + this.User.last_name;
            // $('#updateProfileModal').modal('hide');
            $("#preloader").css('display','none');
            userForm.reset();
            this.userUpdateStatusCode = result.statusCode;
            $('#profilesuccessModal').modal('show');
            let obj = {
              action : "change_community",
              updated_by : updated_by,
              user_id : updated_by
            };

            this.updateNotification(obj);
          }
        });
    }
  }

  updateNotification(obj){
    this.userService.updateNotification(obj)
      .subscribe(notification =>{
        const theCommunity = JSON.parse(localStorage.getItem('currentUser'));
        this.userService.getNotification(theCommunity.user.userid).subscribe(res => {
          if (res.success) {
            this.notificationList = [];
            this.getNotificationCount = res.data.length;
            if (res.data.length > 0) {
              for (let i = 0; i < res.data.length; i++) {
                const obj = {
                  'content': res.data[i].content,
                  'sender': res.data[i].sender,
                  'msg_id': res.data[i].msg_id,
                  'licence_user_id': res.data[i].licence_user_id
                };
                this.notificationList.push(obj);
                this.noNotification = true;
              }
            } else {
              this.noNotification = false;
            }
          }
        });
      });
  }

  closeSuccessModal(){
    $('#profilesuccessModal').modal('hide');
    this.userUpdateStatusCode = "";
    if(this.userForm){
      this.userForm.reset();
    }
    this.isDataShow = false;
    this.loginMsg = '';
    if(this.redirectUrl != ''){
      location.replace(this.redirectUrl);
    }else{
      window.close();
    }
  }

  checkValidNumber(e){
    let str = e.target.value.trim();
    let res : boolean = false;

    let newSupRegex = new RegExp("\\.");
    let validTxt = newSupRegex.test(str);

    if(!validTxt){
      if (!isNaN(str.replace(/[^a-zA-Z]/g, ""))) {
        if(str.length > 5 && str.length < 18) {
          try {
            this.parse = parse(str);
            // Print number in the international format.
            res = isValidNumber(this.parse);
            var num  = formatNumber(str, 'International');
            this.User.phone = num.trim();
            if(this.parse && this.parse.country){
              if($.inArray(this.parse.country,this.countryCodeList)) {
                var index = this.countryCodeList.map(obj => obj.iso2).indexOf(this.parse.country);
                this.User.country = this.countryCodeList[index].name;
              }
            }
          } catch (error){
            this.errorMsg = "202";
          }
        } else if(str.length == 0){
          res = true;
        }
      }
    } else {
      this.errorMsg = "202";
    }

    if(!res) {
      this.errorMsg = "203";
    } else {
      if(str.length > 0){
        this.errorMsg = "";
      } else {
        this.errorMsg = "205";
      }
    }
  }

  trimData(){
    if(this.User.first_name){
      this.User.first_name = this.User.first_name.trim();
    }
    if(this.User.last_name){
      this.User.last_name = this.User.last_name.trim();
    }
    if(this.User.mail_id){
      this.User.mail_id = this.User.mail_id.trim();
    }
    if(this.User.phone){
      this.User.phone = this.User.phone.trim();
    }
    if(this.User.designation){
      this.User.designation = this.User.designation.trim();
    }
  }

  changeCountry(e){
    this.User.phone = "";
    // this.contact = "";
    if(this.countryId){
      let ind = this.countryCodeList.findIndex(c=> c.iso2 == this.countryId);
      if(ind > -1){
        this.User.country = this.countryCodeList[ind].name;
        this.countryCode = this.countryCodeList[ind].code;
      }else{
        this.User.country = undefined;
        this.countryCode = null;
      }
      // this.errorMsg = "205";
      this.errorMsg = "";
    } else {
      this.User.country = "";
      this.errorMsg = "";
      this.User.phone = "";
    }
  }
  ngOnDestroy(){
    $('body').removeClass("isolatedBg");
  }
}



// WEBPACK FOOTER //
// ./src/app/Screens/isolated-profile-update/isolated-profile-update.component.ts